import React from "react";

import { IconNoResults } from "../../../../assets";
import Text from "../../../common/Text/Text";
import * as strings from "../../../../strings";

const SearchBarNoResults = () => {
	return (
		<div className={"SearchBarNoResults"}>
			<IconNoResults />
			<Text tag={"p"}>{strings.MISC_NO_RESULTS}</Text>
			<Text tag={"p"}>{strings.CONTROLS_SEARCH_ADJUST}</Text>
		</div>
	);
};

export default SearchBarNoResults;
